export const usePage = (path: string | undefined): string => {
  return path?.split('/').slice(-1)[0] || '';
};
